import Api from "../state/Api"
import { QuotationValidationStore } from "../state/validation-stores"
let timer
export default class Utils {

    static getCountry(origin,isCity=false){
        let city;
        let country;
       if(origin.includes(";")){
           let values = origin.split(";");
           if(values.length===1){
            return origin
           }
           city = values[0];
           country = values[values.length-1].split("[")[0].trim();
           if(country.includes(":")){
            country = values[values.length-2].split("[")[0].trim();
           }
       }else if(origin.includes(",")){
            let values = origin.split(",");
            if(values.length===1){
                return origin
               }
           city = values[0].split("(")[0].trim();
            country = values[values.length-1].split("(")[0].trim();
       }else{
         return origin
       }
       if(isCity){
         return city;
       }
       return `${city}, ${country}`
    }

    static N(num, currency = 'INR') {
        if (!num) return ''
        if (isNaN(num)) return '0.00'
        num = Number(num)
        return num.toLocaleString('en-IN', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
            style: 'currency',
            currency: currency
        })
    }
    static N1(num, currency = 'INR') {
        if (!num) num = 0
        if (isNaN(num)) num = 0
        num = Number(num)
        return num.toLocaleString('en-IN', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
            style: 'currency',
            currency: currency
        })
    }
    static getCurrentDateString(today = new Date()) {
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        const yyyy = today.getFullYear();

        const ret = `${yyyy}-${mm}-${dd}`
        return ret
    }
    static getCurrentDateStringFuture(today = new Date()) {
        let nextDay = today.getDate() + 1;
        let nextMonth = today.getMonth() + 1;
        let nextYear = today.getFullYear();

        if (nextDay > new Date(nextYear, nextMonth, 0).getDate()) {
            nextDay = 1;
            nextMonth++;
        }

        if (nextMonth > 12) {
            nextDay = 1;
            nextMonth = 1;
            nextYear++;
        }

        const dd = String(nextDay).padStart(2, '0');
        const mm = String(nextMonth).padStart(2, '0');
        const yyyy = nextYear;

        const ret = `${yyyy}-${mm}-${dd}`;
        console.log(ret);
        console.log(today);
        return ret;
    }
    static getTomorrowDateString(today = new Date()) {
        const dd = String(today.getDate() + 1).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        const yyyy = today.getFullYear();

        const ret = `${yyyy}-${mm}-${dd}`
        return ret
    }
    static getMaxDateString(date) {
        const today = new Date(date);
        today.setDate(today.getDate() + 45)
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        const yyyy = today.getFullYear();

        const ret = `${yyyy}-${mm}-${dd}`
        return ret
    }
    static d2(num) {
        return String(num).padStart(2, '0')
    }
    static millis2duration(millis) {
        const d2 = Utils.d2
        let diff = millis
        let seconds = Math.round(diff / 1000)
        let minutes = Math.round(seconds / 60)
        let hours = Math.round(minutes / 60)
        let days = Math.round(hours / 24)

        seconds = seconds % 60
        minutes = minutes % 60
        hours = hours % 24
        let duration = ''
        if (days > 0) duration = days + 'd, '
        if (days > 0 || hours > 0) duration += d2(hours) + 'h:'
        duration += d2(minutes) + 'm:' + d2(seconds) + 's'
        return {
            duration, hours, minutes, seconds
        }
    }
    static getDateDifference(millis1, millis2) {
        let diff = (millis1 > millis2) ? (millis1 - millis2) : (millis2 - millis1)
        return Utils.millis2duration(diff)
    }
    static formatToDateTime(millis, withMonth = false) {
        if (!millis) return ''
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        const today = new Date(millis);
        const dd = String(today.getDate()).padStart(2, '0')
        let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        if (withMonth) mm = months[today.getMonth()]
        const yyyy = today.getFullYear();
        let hours = String(today.getHours())
        const mins = String(today.getMinutes()).padStart(2, '0')
        let ampm = 'AM'
        if (hours > 12) {
            hours -= 12
            ampm = 'PM'
        }
        if (hours == 12) {
            ampm = 'PM'
        }

        const ret = `${dd}-${mm}-${yyyy}; ${hours}:${mins} ${ampm}`
        return ret
    }

    static formatdatetimetocovert(date, time) {
        if (date.length == 0) return ""
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        const today = new Date(date);
        let l = time.split(':')
        const dd = String(today.getDate()).padStart(2, '0')
        let mm = months[today.getMonth()]
        const yyyy = today.getFullYear();
        if (time.length == 0) return `${dd}-${mm}-${yyyy};`
        let hours = Number(l[0])
        const mins = String(l[1]).padStart(2, '0')
        let ampm = 'AM'
        if (hours > 12) {
            hours -= 12
            ampm = 'PM'
        }
        if (hours == 12) {
            ampm = 'PM'
        }
        hours = String(hours).padStart(2, '0')
        const ret = `${dd}-${mm}-${yyyy}; ${hours}:${mins} ${ampm}`
        return ret
    }

    static formattimetocovertampm(time) {

        let l = time.split(':')
        if (time.length == 0) return ``
        let hours = Number(l[0])
        const mins = String(l[1]).padStart(2, '0')
        let ampm = 'AM'
        if (hours > 12) {
            hours -= 12
            ampm = 'PM'
        }
        if (hours == 12) {
            ampm = 'PM'
        }
        hours = String(hours).padStart(2, '0')
        const ret = `${hours}:${mins} ${ampm}`
        return ret
    }

    static diff_hours(dt2, dt1) {
        if (dt1.length > 0) {
            let nv = new Date()
            let nv2 = new Date()
            if (dt2.length == "") {
                nv2 = new Date()
            } else {
                nv2 = new Date(dt2.split(';')[0])
                let l = dt2.split(';')[1]
                if (l.length > 0) {
                    nv2.setHours(+l.split(':')[0])
                    nv2.setMinutes(+l.split(':')[1])
                }
            }
            nv = new Date(dt1.split(';')[0])
            let l = dt1.split(';')[1]
            if (l.length > 0) {
                nv.setHours(+l.split(':')[0])
                nv.setMinutes(+l.split(':')[1])
            }
            var diff = (nv2.getTime() - nv.getTime()) / 1000;
            diff /= (60 * 60);
            return Math.abs(Math.round(diff)) + "H";
        } else {
            return ""
        }


    }

    static formatToDate(millis, withMonth = false) {
        if (!millis) return ''
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        const today = new Date(millis);
        const dd = String(today.getDate()).padStart(2, '0')
        let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        if (withMonth) mm = months[today.getMonth()]
        const yyyy = today.getFullYear();
        let hours = String(today.getHours())
        const mins = String(today.getMinutes()).padStart(2, '0')

        const ret = `${yyyy}-${mm}-${dd}`
        return ret
    }
    static formatToDateTime1(dt, tm) {
        if (!dt) return ''
        let cdt = Utils.convertDateformat(dt)
        if (!tm) return cdt
        let hours = Number(tm.split(':')[0])
        let retTime = ''
        if (hours < 12) {
            retTime = `${hours}:00 AM`
        } else {
            retTime = `${hours - 12}:00 PM`
        }
        const ret = `${cdt} ${retTime}`
        return ret
    }
    static isBlank(s) {
        return !s || (s && !(s.trim().length))
    }
    static getNextFriday(date = new Date()) {
        const dateCopy = new Date(date.getTime())
        const nextFriday = new Date(
            dateCopy.setDate(
                dateCopy.getDate() + ((7 - dateCopy.getDay() + 5) % 7 || 7),
            ),
        )
        return nextFriday
    }
    static newDate(d) { // This is to get a new date from datestring in dd-mm-yyyy format
        //console.log('insidenewDate=========',d)
        if (!d || d.length < 8) return new Date()
        let dt = d
        if (dt.length > 10) dt = d.substr(0, 10)
        let p = dt.split('-')
        let d1 = dt
        if (p[2].length === 4) d1 = `${p[2]}-${p[1]}-${p[0]}`

        let ret = new Date(d1)
        //console.log('########newdate=', d1, ret)
        if (ret instanceof Date && !isNaN(ret)) return ret
        //console.log('########')
        //console.log('%%%%%%%$$$')
        //console.log('INSIDE newDate=',d,dt,d1,ret)
        return new Date()
    }
    static formatDate(dtless1) {
        if (!dtless1)
            return '';
        let dt = dtless1 // Utils.addDays(dtless1,1) - Temp comment, as in qa days seem correct.
        //console.log('>>>>>>>DATERECEIVED=', dtless1)
        const dd = String(dt.getDate()).padStart(2, '0');
        const mm = String(dt.getMonth() + 1).padStart(2, '0'); //January is 0!
        const yyyy = dt.getFullYear();

        let ret = `${yyyy}-${mm}-${dd}`
        return Utils.convertDateformat(ret)
    }

    static yyyymmdd(dt) {
        const dd = String(dt.getDate()).padStart(2, '0');
        const mm = String(dt.getMonth() + 1).padStart(2, '0'); //January is 0!
        const yyyy = dt.getFullYear();

        let ret = `${yyyy}-${mm}-${dd}`
        return ret
    }
    static ddmmyyyy(dt) {
        const dd = String(dt.getDate()).padStart(2, '0');
        const mm = String(dt.getMonth() + 1).padStart(2, '0'); //January is 0!
        const yyyy = dt.getFullYear();
        let ret = `${dd}-${mm}-${yyyy}`
        return ret
    }
    static ddmmyyyystring(dt) {
        if (dt) {
            dt = dt.split('-')
            if (dt.length == 3) {
                return `${dt[2]}-${dt[1]}-${dt[0]}`
            } else {
                return ""
            }
        } else {
            return ""
        }

    }
    static mmddyyyy(dt) {
        const dd = String(dt.getDate()).padStart(2, '0');
        const mm = String(dt.getMonth() + 1).padStart(2, '0'); //January is 0!
        const yyyy = dt.getFullYear();
        let ret = `${mm}-${dd}-${yyyy}`
        return ret
    }
    static setdate(day) {
        Date.prototype.addDays = function (days) {
            var date = new Date(this.valueOf());
            date.setDate(date.getDate() + days);
            return date;
        }
        var date = new Date().addDays(day);
        return this.mmddyyyy(date)
    }

    static setcrddate(crd, day) {
        Date.prototype.addDays = function (days) {
            var date = new Date(this.valueOf());
            date.setDate(date.getDate() + days);
            return date;
        }
        var date = new Date(crd).addDays(day);
        return this.mmddyyyy(date)
    }


    static reformatSuffixedDate(dateString) {
        const months = ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        if (dateString.length >= 10) {
            let t = dateString.slice(dateString.length - 10)
            let arr = t.split('-')
            if (arr.length === 3) {
                let mmm = months[Number.parseInt(arr[1])]
                const ret = dateString.slice(0, dateString.length - 10) + `${arr[0]}-${mmm}`
                return ret
            }
        }
        return dateString
    }
    static formatDateShort(dtless1) {
        let dt = Utils.formatDate(dtless1).split('-')
        return dt[0] + '-' + dt[1]
    }
    static convertDateformat(idate) {
        //console.log('%%%%%%%%%CONVERTING DATE FORMAT=', idate)
        if (!idate || idate.length != 10) return idate
        let parts = idate.split('-')
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
        let monName = months[Number(parts[1]) - 1]
        let ret = `${parts[2]}-${monName}-${parts[0]}`
        /*if (ret === 'NaN-NaN') {
            console.log('#$%', idate, ret)
        }*/
        return ret
    }
    static displayNonStackable(shipmentType, shipmentScope) {
        const st = shipmentType
        const sc = shipmentScope
        let result
        if (st.toLowerCase().includes('fcl')) {
            if (sc === 'Port-to-Port') {
                result = false;
            } else if ((st.includes('Factory/Dock') && sc === 'Door-to-Port') || (st.includes('Dock/Factory') && sc === 'Port-to-Door')) {
                result = false
            } else {
                result = (!st.includes('Factory/Factory'))
            }
        } else {
            result = true;
        }
        return result
        // return st.toLowerCase().includes('fcl') ? (sc === 'Port-to-Port') ? false : !st.includes('Factory/Factory') : true;
        // if (st.indexOf('FCL') >= 0) {
        //     if (st.indexOf('De-stuffing') >= 0) {
        //         if (sc.endsWith('Door')) return true
        //         return false
        //     }
        //     if (sc.startsWith('Door')) return true
        //     return false
        // }
        // return true
    }
    static displayTemperatureControlled(st) {
        console.log('INSIDE displayTemperatureControlled', st)
        if (st.indexOf('FCL') >= 0 && st.indexOf('Factory') >= 0) return true
        if (st.indexOf('Air') >= 0) return true
        return false
    }
    static R(num) {
        return Math.round(num * 10000) / 10000
    }
    static R2(num) {
        return Math.round(num * 100) / 100.0
    }
    static getDays(start, end) {
        //console.log('start date=', start, 'end date=', end)
        const oneDay = 1000 * 60 * 60 * 24;
        const diffInTime = end.getTime() - start.getTime();
        const diffInDays = Math.round(diffInTime / oneDay);
        return diffInDays;
    }
    static addDays(dt, days) {
        let tempdt = new Date(dt)
        tempdt.setDate(tempdt.getDate() + days)
        //console.log('*** ADDDAYS ***', dt, '***', tempdt)
        return tempdt
    }
    static isUnloc(s) {
        let tags = s.match(/.*\(([A-Z]*)\)/)
        if (tags && tags[1].length === 5) return true
        return false
    }
    static compareDates(s1, s2) {
        if (!s1 || !s2) return 0
        if (s1.length != 10 || s2.length != 10) return 0
        let p
        p = s1.split('-')
        let d1 = p[2] + p[1] + p[0]
        p = s2.split('-')
        let d2 = p[2] + p[1] + p[0]
        return d1.localeCompare(d2)
    }

    static isEmail(email) {
        return email !== '' && email.toString().match(/^[a-zA-Z0-9_.+]+(?<!^[0-9]*)@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/)
    }

    static getStuffingAndDeStuffingType(shipmentType) {
        return shipmentType
            .toString()
            .substring(shipmentType.indexOf('(') + 1, shipmentType.indexOf(')'))
            .split('/')
            .map(type => type.trim());
    }

    static stdUnits(n, unit) {
        switch (unit) {
            case 'Cms': return n
            case 'MM': return n / 10.0
            case 'Inches': return n * 2.5
            case 'Meters': return n * 100
            case 'Feet': return n * 30.0
            case 'Kgs': return n
            case 'Tons': return n * 1000
            case 'Lbs': return n * 0.454545
            case 'CBM': return n
            case 'cu ft': return n * 0.027
            default: return n
        }
    }

    static stdkgtoUnitsconvert(nkg, unit) {
        switch (unit) {
            case 'Kgs': return nkg
            case 'Tons': return (nkg / 1000).toFixed(2)
            case 'Lbs': return (nkg * 2.2046226218).toFixed(2)
            default: return nkg
        }
    }

    static stdcmdtoUnits(n, unit) {
        switch (unit) {
            case 'Cms': return n
            case 'MM': return n * 10.0
            case 'Inches': return n / 2.5
            case 'Meters': return n / 100
            case 'Feet': return n / 30.0
            default: return n
        }
    }

    static checkAddress(address) {
        var country_list = ["afghanistan", "albania", "algeria", "andorra", "angola", "anguilla", "antigua & barbuda", "antigua and barbuda", "argentina", "armenia", "aruba", "australia", "austria", "azerbaijan", "bahamas", "bahrain", "bangladesh", "barbados", "belarus", "belgium", "belize", "benin", "bermuda", "bhutan", "bolivia", "bosnia & herzegovina", "bosnia and herzegovina", "botswana", "brazil", "british virgin islands", "brunei", "bulgaria", "burkina faso", "burundi", "cambodia", "cameroon", "cape verde", "cayman islands", "chad", "chile", "china", "colombia", "congo", "cook islands", "costa rica", "cote d ivoire", "croatia", "cruise ship", "cuba", "cyprus", "czech republic", "denmark", "djibouti", "dominica", "dominican republic", "ecuador", "egypt", "el salvador", "equatorial guinea", "estonia", "ethiopia", "falkland islands", "faroe islands", "fiji", "finland", "france", "french polynesia", "french west indies", "gabon", "gambia", "georgia", "germany", "ghana", "gibraltar", "greece", "greenland", "grenada", "guam", "guatemala", "guernsey", "guinea", "guinea bissau", "guyana", "haiti", "honduras", "hong kong", "hungary", "iceland", "india", "indonesia", "iran", "iraq", "ireland", "isle of man", "israel", "italy", "jamaica", "japan", "jersey", "jordan", "kazakhstan", "kenya", "kuwait", "kyrgyz republic", "laos", "latvia", "lebanon", "lesotho", "liberia", "libya", "liechtenstein", "lithuania", "luxembourg", "macau", "macedonia", "madagascar", "malawi", "malaysia", "maldives", "mali", "malta", "mauritania", "mauritius", "mexico", "moldova", "monaco", "mongolia", "montenegro", "montserrat", "morocco", "mozambique", "namibia", "nepal", "netherlands", "netherlands antilles", "new caledonia", "new zealand", "nicaragua", "niger", "nigeria", "norway", "oman", "pakistan", "palestine", "panama", "papua new guinea", "paraguay", "peru", "philippines", "poland", "portugal", "puerto rico", "qatar", "reunion", "romania", "russia", "rwanda", "saint pierre & miquelon", "saint pierre and miquelon", "samoa", "san marino", "satellite", "saudi arabia", "senegal", "serbia", "seychelles", "sierra leone", "singapore", "slovakia", "slovenia", "south africa", "south korea", "spain", "sri lanka", "st kitts & nevis", "st kitts and nevis", "st lucia", "st vincent", "st. lucia", "sudan", "suriname", "swaziland", "sweden", "switzerland", "syria", "taiwan", "tajikistan", "tanzania", "thailand", "timor l'este", "togo", "tonga", "trinidad & tobago", "trinidad and tobago", "tunisia", "turkey", "turkmenistan", "turks & caicos", "turks and caicos", "uganda", "ukraine", "united arab emirates", "united kingdom", "uruguay", "uzbekistan", "venezuela", "vietnam", "virgin islands (us)", "yemen", "zambia", "zimbabwe", "usa", "United States", "united states of america", "uae", "united arab emirates", "uk", "united kingdom"];
        let l = false
        let a = address.toLowerCase().split(',')
        for (let i = 0; i < a.length; i++) {    
            if (country_list.indexOf(a[i].trim()) > -1) {
                l = true
                i = a.length + 1
            }
        }
        if (l == false) {
            let a = address.toLowerCase().split(' ')
            for (let i = 0; i < a.length; i++) {
                if (country_list.indexOf(a[i].trim()) > -1) {
                    l = true
                    i = a.length + 1
                }
            }
        }
        return l
    }

    static VehicleAggregation(vehicledetails){
        const vehicles = [];
        vehicledetails.forEach((vehicle)=>{
             vehicles.push(`${vehicle.numVehicles} x ${vehicle.vType}`)
        })
        return vehicles
     }

     static AirCargoCalculation(cargodetails){
        const totalCalulation = {productType : [] ,quantity : 0,totalWeight:0,dimensions:{totalLength:0,totalWidth:0,totalHeight:0}};
        console.log("the dimensions are ",cargodetails[0])
        cargodetails.forEach(e => {
            totalCalulation.totalWeight += parseInt(e.weight.value) 
            totalCalulation.quantity += parseInt(e.quantity)
            totalCalulation.productType.push(e.packageType);
            totalCalulation.dimensions.totalLength += parseInt(e.dimensions.length);
            totalCalulation.dimensions.totalWidth += parseInt(e.dimensions.width);
            totalCalulation.dimensions.totalHeight += parseInt(e.dimensions.height)
          });   
          console.log("the answer total is ",totalCalulation.dimensions)
       return totalCalulation;
     }

   static CalculateCargo(cargodetails){
        const totalCalulation = {totalWeight : 0,totalVolume:0,quantity:0};
        cargodetails.forEach(e => {
          totalCalulation.totalWeight += parseInt(e.totalWeight.value) 
          totalCalulation.totalVolume += parseInt(e.totalVolume.value) 
          totalCalulation.quantity += parseInt(e.quantity)
        });   
     
        totalCalulation.totalWeight = Utils.R(
         totalCalulation.totalWeight
       );
     
       totalCalulation.totalVolume = Utils.R(
         totalCalulation.totalVolume
       );
     
       return totalCalulation;
     }

    static checkZipcode(zip) {
        switch (true) {
            case /(^(?:AD)*(\d{3})$)/.test(zip): return true; break;
            case /(^(\d{4})$)/.test(zip): return true; break;
            case /(^(\d{6})$)/.test(zip): return true; break;
            case /(^[A-Z]?\d{4}[A-Z]{0,3}$)/.test(zip): return true; break;
            case /(^(?:FI)*(\d{5})$)/.test(zip): return true; break;
            case /(^(?:AZ)*(\d{4})$)/.test(zip): return true; break;
            case /(^(\d{5})$)/.test(zip): return true; break;
            case /(^(?:BB)*(\d{5})$)/.test(zip): return true; break;
            case /(^(\d{3}\d?)$)/.test(zip): return true; break;
            case /(^([A-Z]{2}\d{2})$)/.test(zip): return true; break;
            case /(^([A-Z]{2}\d{4})$)/.test(zip): return true; break;
            case /(^\d{5}-\d{3}$)/.test(zip): return true; break;
            case /(^([ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]) ?(\d[ABCEGHJKLMNPRSTVWXYZ]\d)$)/.test(zip): return true; break;
            case /(^(\d{7})$)/.test(zip): return true; break;
            case /(^(?:CP)*(\d{5})$)/.test(zip): return true; break;
            case /(^\d{3}\s?\d{2}$)/.test(zip): return true; break;
            case /(^([a-zA-Z]\d{4}[a-zA-Z])$)/.test(zip): return true; break;
            case /(^(?:FO)*(\d{3})$)/.test(zip): return true; break;
            case /(^([Gg][Ii][Rr]\s?0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z]))))\s?[0-9][A-Za-z]{2})$)/.test(zip): return true; break;
            case /(^((?:(?:[A-PR-UWYZ][A-HK-Y]\d[ABEHMNPRV-Y0-9]|[A-PR-UWYZ]\d[A-HJKPS-UW0-9])\s\d[ABD-HJLNP-UW-Z]{2})|GIR\s?0AA)$)/.test(zip): return true; break;
            case /(^((97|98)\d{3})$)/.test(zip): return true; break;
            case /(^(969\d{2})$)/.test(zip): return true; break;
            case /(^(?:HR)*(\d{5})$)/.test(zip): return true; break;
            case /(^(?:HT)*(\d{4})$)/.test(zip): return true; break;
            case /(^(D6W|[AC-FHKNPRTV-Y][0-9]{2})\s?([AC-FHKNPRTV-Y0-9]{4}))/.test(zip): return true; break;
            case /(^(\d{10})$)/.test(zip): return true; break;
            case /(^(\d{3})$)/.test(zip): return true; break;
            case /(^\d{3}-\d{4}$)/.test(zip): return true; break;
            case /(^(\d{4}(\d{4})?)$)/.test(zip): return true; break;
            case /(^(?:LT)*(\d{5})$)/.test(zip): return true; break;
            case /(^(?:L-)?\d{4}$)/.test(zip): return true; break;
            case /(^(?:LV)*(\d{4})$)/.test(zip): return true; break;
            case /(^MD-\d{4}$)/.test(zip): return true; break;
            case /(^969\d{2}(-\d{4})$)/.test(zip): return true; break;
            case /(^9695\d{1}$)/.test(zip): return true; break;
            case /(^[A-Z]{3}\s?\d{4}$)/.test(zip): return true; break;
            case /(^(\d{4}\s?[a-zA-Z]{2})$)/.test(zip): return true; break;
            case /(^\d{2}-\d{3}$)/.test(zip): return true; break;
            case /(^(97500)$)/.test(zip): return true; break;
            case /(^00[679]\d{2}(?:-\d{4})?$)/.test(zip): return true; break;
            case /(^\d{4}-\d{3}\s?[a-zA-Z]{0,25}$)/.test(zip): return true; break;
            case /(^(96940)$)/.test(zip): return true; break;
            case /(^((97|98)(3|4|7|8)\d{2})$)/.test(zip): return true; break;
            case /(^(?:SE)?\d{3}\s\d{2}$)/.test(zip): return true; break;
            case /(^(STHL1ZZ)$)/.test(zip): return true; break;
            case /(^(?:SI)*(\d{4})$)/.test(zip): return true; break;
            case /(^(4789\d)$)/.test(zip): return true; break;
            case /(^([A-Z]{2}\d{5})$)/.test(zip): return true; break;
            case /(^(?:CP)*(\d{4})$)/.test(zip): return true; break;
            case /(^([A-Z]\d{3})$)/.test(zip): return true; break;
            case /(^(TKCA 1ZZ)$)/.test(zip): return true; break;
            case /(^\d{5}(-\d{4})?$)/.test(zip): return true; break;
            case /(^008\d{2}(?:-\d{4})?$)/.test(zip): return true; break;
            case /(^(986\d{2})$)/.test(zip): return true; break;
            default: return false
        }
    }

    static getUNCodeFromLocationString(locString) {
        if (locString.includes('(') && locString.includes(')')) {
            return locString
                .trim()
                .slice(locString.lastIndexOf("(") + 1, locString.length - 1)
                .trim();
        } else {
            return locString
        }
    }

    static isUnLoc1(locString) {
        locString = Utils.getUNCodeFromLocationString(locString);
        return locString.length === 5 && /^[A-Z0-9]+$/.test(locString)
    };

    static validunloc(a1, a2, loc, sope, key) {
        console.log("checinh");
        if (a1.includes(sope)) {
            let l = Utils.getUNCodeFromLocationString(loc)
            if (Utils.isUnLoc1(loc)) {
                Api.checkUnloc(l, (data) => {
                    if (data != -1) {
                        QuotationValidationStore.quotationValidMap[key] = true
                    } else {
                        QuotationValidationStore.quotationValidMap[key] = false
                    }
                })
            } else {
                QuotationValidationStore.quotationValidMap[key] = false
            }
        } else {
            QuotationValidationStore.quotationValidMap[key] =
                loc !== "" && (a2.includes(sope)
                    ? !Utils.isUnLoc1(loc)
                    : true);
        }
    }

    static validunloc1(loc, key) {
        if (loc == "") {
            QuotationValidationStore.quotationValidMap[key] = true
        } else {
            let l = Utils.getUNCodeFromLocationString(loc)
            if (Utils.isUnLoc1(loc)) {
                Api.checkUnloc(l, (data) => {
                    if (data != -1) {
                        QuotationValidationStore.quotationValidMap[key] = true
                    } else {
                        QuotationValidationStore.quotationValidMap[key] = false
                    }
                })
            } else {
                QuotationValidationStore.quotationValidMap[key] = false
            }
        }
    }

    static gettimer(start) {
        // get total seconds between the times
        var delta = Math.abs(Date.now() - start) / 1000;

        // calculate (and subtract) whole days
        var days = Math.floor(delta / 86400).toString();
        if (days.length == 1) days = '0' + days
        delta -= days * 86400;

        // calculate (and subtract) whole hours
        var hours = (Math.floor(delta / 3600) % 24).toString();
        if (hours.length == 1) hours = '0' + hours
        delta -= hours * 3600;

        // calculate (and subtract) whole minutes
        var minutes = (Math.floor(delta / 60) % 60).toString();
        if (minutes.length == 1) minutes = '0' + minutes

        return `${days}D/${hours}H:${minutes}M`
    }

    static debounce(func, timeout = 200) {
        return (...args) => {
            clearTimeout(timer)
            timer = setTimeout(() => { func.apply(this, args); }, timeout)
        }
    }
    static toNum(a) {
        let n = 0
        if (typeof a === 'string') a = a.replaceAll(',', '')
        n = Number(a)
        if (isNaN(n)) n = 0
        return n
    }
}